module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-breadcrumb/gatsby-browser.js'),
      options: {"plugins":[],"useAutoGen":true,"autoGenHomeLabel":"TOP","exclude":["**/offline-plugin-app-shell-fallback/**"],"crumbLabelUpdates":[{"pathname":"/about","crumbLabel":"About"},{"pathname":"/alliance","crumbLabel":"Alliance"},{"pathname":"/investment","crumbLabel":"Investment"},{"pathname":"/case","crumbLabel":"Case"},{"pathname":"/news","crumbLabel":"News"}],"trailingSlashes":true,"usePathPrefix":"/profile/mocc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NKDGQQ9","defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"includeInDevelopment":false,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
